<template>
  <div
    ref="scrollContainerRef"
    class="scroll-horizontal"
    @mousedown="handleMouseDown"
    @mousemove="handleMouseMove"
    @mouseup="handleMouseUp"
    @mouseleave="handleMouseUp"
    @click.capture="handleClick"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
const scrollContainerRef = ref<HTMLElement>()
const isDragging = ref(false)
const hasDragged = ref(false)
const startX = ref(0)
const scrollStart = ref(0)
const isScrolling = ref(false)
const startTime = ref(0)

function handleMouseDown(event: MouseEvent) {
  if (!scrollContainerRef.value) {
    return
  }

  isDragging.value = true
  hasDragged.value = false
  startX.value = event.clientX
  startTime.value = Date.now()
  scrollStart.value = scrollContainerRef.value.scrollLeft
  isScrolling.value = false

  event.preventDefault()
}

function handleMouseMove(event: MouseEvent) {
  if (!isDragging.value || !scrollContainerRef.value) {
    return
  }

  const deltaX = event.clientX - startX.value
  const deltaTime = Date.now() - startTime.value

  if (Math.abs(deltaX) > 5 || deltaTime > 100) {
    hasDragged.value = true
  }

  isScrolling.value = true
  scrollContainerRef.value.scrollLeft = scrollStart.value - deltaX
  event.preventDefault()
}

function handleMouseUp() {
  isDragging.value = false
  isScrolling.value = false

  setTimeout(() => {
    hasDragged.value = false
  }, 50)
}

function handleClick(event: MouseEvent) {
  if (hasDragged.value) {
    event.stopPropagation()
  }
}
</script>

<style lang="scss" scoped>
.scroll-horizontal {
  overflow: auto hidden;
  scrollbar-width: none;
  user-select: none;
  cursor: grab;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
